import React from 'react'
import CommercialDocsAttestationFaqMain from './CommercialDocsAttestationFaqMain'
import FaqHead from '../../../HomePage/Faq/FaqHead'

const CommercialDocsAttestationFaq = () => {
  return (
    <div className="faqContainer">
      <div className="faqContent">
        <FaqHead heading="Commercial Document Apostille Service in Bangalore (Customer POV)" />
        <CommercialDocsAttestationFaqMain />
      </div>
    </div>
  )
}

export default CommercialDocsAttestationFaq
